import { TrackAvailabilityOptionDto } from '@cratehackers/api-client';
import { IonItem, IonList } from '@ionic/react';
import React from 'react';
import { openExternalLink } from '../../utils/openExternalLink';
import {
  createAmazonAffiliateUrl,
  createBeatportAffiliateUrl,
  isBeatportUrl,
} from '../tracks/affiliateLinks';

interface TrackDropdownItemProps {
  artist: string;
  title: string;
  dropdownItem: TrackAvailabilityOptionDto;
}

export const TrackDropdownItem: React.FC<TrackDropdownItemProps> = ({
  artist,
  title,
  dropdownItem,
}) => {
  const rawUrl = JSON.stringify(dropdownItem.url).replace(/"/g, '');

  let link: string;
  if (rawUrl === 'https://www.amazon.com/s?k=') {
    link = createAmazonAffiliateUrl(artist, title);
  } else if (isBeatportUrl(rawUrl)) {
    link = createBeatportAffiliateUrl(artist, title);
  } else {
    link = `${dropdownItem.url}${title} ${artist}`;
  }

  return (
    <IonList lines="none">
      {dropdownItem.url && (
        <IonItem
          className="resource-name-text"
          onClick={() => openExternalLink(link)}
        >
          {dropdownItem.name}
        </IonItem>
      )}
    </IonList>
  );
};
